import { enableProdMode, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { LanguageService } from './app/core/services/language.service';
import { LocaleProvider } from './app/core/providers/locale.provider';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateMatPaginatorIntl } from './app/core/common/translate-mat-paginator-intl';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LanguageInterceptor } from './app/core/interceptors/language.interceptor';
import { JwtInterceptor } from './app/core/interceptors/jwt.interceptor';
import { LoaderInterceptor } from './app/core/interceptors/loader.interceptor';
import { HttpErrorInterceptor } from './app/core/interceptors/http-error.interceptor';
import { GlobalErrorHandler } from './app/core/common/global-error-handler';
import { registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { provideRouter, RouterModule } from '@angular/router';
import { AppComponent } from './app/app.component';
import localeDECH from '@angular/common/locales/de-CH';
import localeENCH from '@angular/common/locales/en-CH';
import localeFRCH from '@angular/common/locales/fr-CH';
import localeITCH from '@angular/common/locales/it-CH';
import { TranslateLoaderProvider } from './app/core/providers/translate-loader.provider';
import { MatFormFieldDefaultOptionsProvider } from './app/core/providers/mat-form-field-default-options.provider';
import { DateAdapterProvider } from './app/core/providers/date-adapter.provider';
import { MatDateFormatProvider } from './app/core/providers/mat-date-format.provider';
import { AppInitializerProvider } from './app/core/providers/app-initializer.provider';
import { ApiBaseUrlProvider } from './app/core/providers/api-base-url.provider';
import { WindowProvider } from './app/core/providers/window.provider';
// Workaround for matedatepicker bug https://github.com/angular/components/issues/28263
import 'moment/locale/de-CH';
import { appRoutes } from './app/app.routes';
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask';


const maskConfig: Partial<NgxMaskConfig> = {
  thousandSeparator: "'",
  decimalMarker: ".",
  prefix: "CHF ",
  allowNegativeNumbers: true,
  dropSpecialCharacters: true,
  placeHolderCharacter: "CHF 0.00",
  leadZero: true
};

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeDECH);
registerLocaleData(localeENCH);
registerLocaleData(localeFRCH);
registerLocaleData(localeITCH);

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(FormsModule, ReactiveFormsModule, BrowserModule, MatIconModule, TranslateModule.forRoot({
      loader: TranslateLoaderProvider
    }), RouterModule),
    provideRouter(appRoutes,
      // withPreloading(PreloadAllModules),
      // withDebugTracing()
    ),
    MatFormFieldDefaultOptionsProvider,
    DateAdapterProvider,
    MatDateFormatProvider,
    AppInitializerProvider,
    ApiBaseUrlProvider,
    LocaleProvider,
    LanguageService,
    {
      provide: MatPaginatorIntl,
      useClass: TranslateMatPaginatorIntl
    },
    { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    WindowProvider,
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideEnvironmentNgxMask(maskConfig)
  ]
})
  .catch(err => console.error(err));
